function e(t){return t!=null&&typeof t=="object"}export{e as i};
//# sourceMappingURL=isObjectLike-es.js.map
